import { useContext, useEffect } from 'react'
import { createPortal } from 'react-dom'

import { OnboardingContext } from 'features/onboarding/context'
import { useUser } from 'hooks/use-user'
import { STORAGE_KEY_PREFIX } from 'features/onboarding/hooks/use-onboarding'

import OnboardingModal from './onboarding-modal'

export default function OnboardingModalPortal() {
  const user = useUser()
  const { state, onboardingQuestionnaireEnabled, closeModal, openModal } =
    useContext(OnboardingContext)
  const storageKey = `${STORAGE_KEY_PREFIX}_${
    user?.id || 'anonymous'
  }_has_seen_onboarding_first_time`

  useEffect(() => {
    const hasSeenOnboarding = localStorage.getItem(storageKey)
    if (!hasSeenOnboarding && onboardingQuestionnaireEnabled) {
      openModal()
      localStorage.setItem(storageKey, 'true')
    }
  }, [onboardingQuestionnaireEnabled, openModal, storageKey])

  if (!onboardingQuestionnaireEnabled) {
    return null
  }

  if (state.isCompleted) {
    return null
  }

  const modalRoot = document.getElementById('onboarding-modal-root')
  if (!modalRoot) {
    return null
  }

  return createPortal(
    <OnboardingModal
      isOpen={state.isOnboardingModalOpen}
      onClose={closeModal}
    />,
    modalRoot,
  )
}
